import _ from 'lodash-es';
import QueryVariable from '~/scripts/services/model/query-variable';

export default class QueryVariablesController {
	/* @ngInject */
	constructor() {
		/** @type {?import('../query-editor/query-editor.controller').default} */
		this.editor = null;

		/** @type {any} */
		this.ngModelCtrl = null;

		/** @type {QueryVariable[]} */
		this.variables = [];

		/** @type {RegExp} */
		this.variableIdRegex = QueryVariable.getVariableIdRegex();
	}

	updateVariable() {
		this.ngModelCtrl.$validate();
		this.editor?.queryEditorForm?.$setDirty();
	}

	$onInit() {
		this.ngModelCtrl.$validators.unique
			= (/** @type {any} */ modelValue) => modelValue.length === _.uniq(_.map(modelValue, 'id')).length;
	}
}
